import { pickBy } from 'lodash-es';

export const mapTagFiltersToString = (tagFilters: Record<string, string[]> | undefined) => {
  const filtered = pickBy(tagFilters, (value) => value.length);
  return Object.keys(filtered).length ? JSON.stringify(filtered) : undefined;
};
